export const LEAD_STATUS = ["New","Attempting Contact","Contacted","Qualified","Analyzing","Offer Prepared","Offer Submitted","Negotiating","Under Contract","Due Diligence","Closing Scheduled","Acquired","Follow-Up","Dead Lead","Archived"];
export const ACQUISITION_STRATEGY = ["Cash Purchase","Subject-To","Seller Financing","Lease Option","Novation","Wholesale Assignment","Fix and Flip","Long-Term Rental","BRRRR","Multifamily Value-Add","Commercial Acquisition"];
export const USER_ROLE = ["System Owner","Administrator","Acquisition Manager","Lead Manager","Underwriter","Transaction Coordinator","Dispositions Manager","Property Manager","Capital Partner","Bookkeeper","Read Only","Vendor"];
export const PRIORITY = ["Urgent","High","Normal","Low"];
export const PROPERTY_TYPE = ["Single Family","Multi Family","Condo","Townhouse","Mobile Home","Land","Commercial","Mixed Use"];
export const OCCUPANCY = ["Owner Occupied","Tenant Occupied","Vacant","Unknown"];
export const CONDITION = ["Excellent","Good","Average","Poor","Distressed"];
export const CONTACT_METHOD = ["Phone","Text","Email","Mail"];
export const TASK_TYPE = ["Call","Email","Text","Meeting","Site Visit","Document","Closing"];
export const TASK_STATUS = ["Open","In Progress","Completed","Cancelled"];
export const OFFER_STATUS = ["Draft","Submitted","Countered","Negotiating","Accepted","Rejected","Expired","Withdrawn"];
export const COMM_TYPE = ["Call","Text","Email","Voicemail","In Person","Mail"];
export const COMM_DIRECTION = ["Inbound","Outbound"];
export const CONTACT_RESULT = ["Connected","No Answer","Left Voicemail","Wrong Number","Not Interested","Callback Requested"];
export const DOC_TYPE = ["Purchase Agreement","Deed","Loan Statement","Title Report","Inspection","Disclosure","Authorization","Photo","Other"];
export const OFFICE_TYPE = ["Assessor","Property Appraiser","Tax Assessor","Tax Collector","County Recorder","Register of Deeds","Clerk of Court","Auditor","Equalization Department"];

export const SUBJECT_TO_COMPLIANCE = [
  "Seller identity verified",
  "Ownership verified",
  "Existing loan documented",
  "Due-on-sale discussion documented",
  "Seller disclosures signed",
  "Attorney review completed (if applicable)",
  "Insurance updated",
  "Escrow instructions completed",
  "Exit strategy documented",
  "Risk review completed",
];

export const STATE_SUBJECT_TO_PACKAGES = {
  NV: {
    label: "Nevada Subject-To Document Package",
    docs: ["Purchase Agreement", "Seller Disclosures", "Trust Documents", "Escrow Instructions", "Seller Acknowledgments"],
  },
  default: {
    label: "Subject-To Document Package",
    docs: ["Purchase Agreement", "Subject-To Addendum", "Seller Disclosures", "Authorization to Release Information", "Escrow Instructions", "Seller Acknowledgment & Disclosure"],
  },
};
export const getSubjectToPackage = (state) => STATE_SUBJECT_TO_PACKAGES[(state || "").toUpperCase()] || STATE_SUBJECT_TO_PACKAGES.default;

export const STATUS_COLORS = {
  "New": "bg-blue-100 text-blue-800 border-blue-200",
  "Qualified": "bg-emerald-100 text-emerald-800 border-emerald-200",
  "Analyzing": "bg-amber-100 text-amber-800 border-amber-200",
  "Offer Submitted": "bg-violet-100 text-violet-800 border-violet-200",
  "Negotiating": "bg-orange-100 text-orange-800 border-orange-200",
  "Under Contract": "bg-indigo-100 text-indigo-800 border-indigo-200",
  "Acquired": "bg-green-100 text-green-800 border-green-200",
  "Dead Lead": "bg-red-100 text-red-800 border-red-200",
};
export const PRIORITY_COLORS = {
  "Urgent": "bg-red-100 text-red-800 border-red-200",
  "High": "bg-orange-100 text-orange-800 border-orange-200",
  "Normal": "bg-slate-100 text-slate-700 border-slate-200",
  "Low": "bg-slate-100 text-slate-500 border-slate-200",
};

export const usd = (n) => new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 }).format(Number(n) || 0);
export const fmtDate = (d) => d ? new Date(d).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" }) : "—";

export const ENQUIRY_STATUS = ["New", "Contacted", "Closed"];
export const ENQUIRY_STATUS_COLORS = {
  "New": "bg-blue-100 text-blue-800 border-blue-200",
  "Contacted": "bg-amber-100 text-amber-800 border-amber-200",
  "Closed": "bg-emerald-100 text-emerald-800 border-emerald-200",
};
